import React, { useMemo } from 'react';
import { Col, Button, Form, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({ outletVillages }) => {
  const { t } = useTranslation();

  const uniqueOutletVillages = useMemo(() => {
    return (
      outletVillages &&
      outletVillages.filter((item, idx) => outletVillages.indexOf(item) === idx)
    );
  }, [outletVillages]);
  return (
    <Row
      gutter={24}
      style={{
        marginBottom: 16,
      }}
    >
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Village')}>
            {uniqueOutletVillages.map((outletVillage, idx) => (
              <Select.Option key={outletVillage.id} value={outletVillage.id}>
                {outletVillage.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Typography.Text>
          <b> {t('Esempio')} </b>
          <Button
            type={'primary-white'}
            onClick={() =>
              window.open('https://dev.arcusnet.it/user_vacancy.pdf', '_blank')
            }
          >
            Modulo richiesta adesione
          </Button>
        </Typography.Text>
      </Col>
      <br />
    </Row>
  );
};

export default React.memo(InfoSection);
